var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"page-content":true,"hide-toolbar-on-scroll":""}},[_c('f7-navbar',[_c('f7-nav-title',{staticClass:"text-madai"},[_vm._v("Boletín")])],1),_c('f7-block',[_c('h2',[_vm._v("Inscríbete a nuestro boletín")]),_c('f7-button',{staticClass:"m-t-30",attrs:{"href":"/gracias/"}},[_vm._v("Inscribirse")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }